import { render, staticRenderFns } from "./ShipLegend.vue?vue&type=template&id=d791d34c&scoped=true&"
import script from "./ShipLegend.vue?vue&type=script&lang=js&"
export * from "./ShipLegend.vue?vue&type=script&lang=js&"
import style0 from "./ShipLegend.vue?vue&type=style&index=0&id=d791d34c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d791d34c",
  null
  
)

export default component.exports